export default function XingIcon() {
  return (
    <svg className="h-6 fill-current" viewBox="0 0 25 25">
      <path d="M12.5 0a12.5 12.5 0 11-.01 25.01A12.5 12.5 0 0112.5 0zm4.04 4.83a.68.68 0 00-.62.44c-.1.26-4.97 8.83-5.14 9.12l3.29 6.02c.1.26.36.43.64.44h2.3c.13 0 .24-.05.31-.15a.36.36 0 000-.36l-3.26-5.95v-.01l5.12-9.04a.36.36 0 000-.36.34.34 0 00-.3-.15h-2.34zM6.84 8a.36.36 0 00-.32.14.36.36 0 00.02.35l1.56 2.7v.02l-2.46 4.33a.36.36 0 000 .36c.07.1.19.16.3.15h2.32a.7.7 0 00.63-.44c.1-.26 2.4-4.25 2.49-4.41L9.79 8.43a.72.72 0 00-.64-.44H6.84z" />
    </svg>
  );
}
